import { render } from "./ConnectionSettingsTab.vue?vue&type=template&id=07d887a6&scoped=true"
import script from "./ConnectionSettingsTab.vue?vue&type=script&lang=js"
export * from "./ConnectionSettingsTab.vue?vue&type=script&lang=js"

import "./ConnectionSettingsTab.vue?vue&type=style&index=0&id=07d887a6&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d887a6"]])

export default __exports__